import Swiper from '../../../node_modules/swiper/swiper-bundle.mjs';
// import { Navigation, Pagination } from '../../../node_modules/swiper/modules/a11y.min.mjs';

export default function initSwiper() {
	let swiper01 = new Swiper(".testimonial-swiper", {
		slidesPerView: 1,
		spaceBetween: 0,
		loop: true,
		autoplay: {
			delay: 12000,
			disableOnInteraction: true,
		},
		pagination: {
			el: ".testimonial-swiper .swiper-pagination",
			clickable: true
		},
	});

	let swiper02 = new Swiper(".posts-swiper", {
		slidesPerView: 1,
		spaceBetween: 20,
		pagination: {
			el: ".posts-swiper .swiper-pagination",
			clickable: true,
		},
		breakpoints: {
			540: {
				slidesPerView: 2,
				spaceBetween: 11,
			},
			768: {
				slidesPerView: 3,
				spaceBetween: 11,
			},

		},
	});



	let swiperMain = new Swiper('.swiper-compare', {
		spaceBetween: 40,
		slidesPerView: 1,
		// thumbs: {
		// 	swiper: swiperThumbs
		// }
		navigation: {
			nextEl: '.swiper-compare .swiper-button-next',
			prevEl: '.swiper-compare .swiper-button-prev',
		},

		breakpoints: {
			1024: {
				slidesPerView: 5,
				spaceBetween: 11,
			},

		},
	});



}


